export enum SalesByCustomerReportTableAccessor {
  CustomerName = 'customerName',
  GrossTotal = 'grossTotal',
  NetTotal = 'netTotal',
}
